import React from 'react';

// Globals
import { useDispatch, useSelector } from 'react-redux';

// UI
import Form, { FormInstance } from 'antd/es/form';

// Locals
import { setCardProps } from '../../actions';
import { CardType } from '../../graphql/api';
import ActivityForm from './ActivityForm';
import DefinitionForm from './DefinitionForm';
import FactoidForm from './FactoidForm';
import GraphicForm from './GraphicForm';
import HighlightForm from './HighlightForm';
import ListForm from './ListForm';
import ProfileForm from './ProfileForm';
import QuizForm from './QuizForm';
import QuoteForm from './QuoteForm';
import ResourceForm from './ResourceForm';
import PollForm from './PollForm';
import VideoForm from './VideoForm';
import TextForm from './TextForm';

// Types
import type { FeedCard, IState } from '../../graphql/types';

export interface ICardCreateProps {
  type: CardType;
  form: FormInstance;
  validationFailed: boolean;
  saving: boolean;
  setFormType: (type: CardType) => void;
  editorRef;
  setEditorRef;
}

const CardCreateForm: React.FC<ICardCreateProps> = ({
  type,
  form,
  validationFailed,
  saving,
  setFormType,
  editorRef,
  setEditorRef,
}) => {
  const dispatch = useDispatch();

  const cardProps = useSelector<IState, Partial<FeedCard> | undefined>(
    state => state.cardProps,
    () => false
  );
  const editingCardProps = useSelector<IState, Partial<FeedCard> | undefined>(
    state => state.editingCardProps
  );

  React.useEffect(() => {
    form.resetFields();
    if (editingCardProps?.type === cardProps?.type) {
      dispatch(setCardProps(editingCardProps));
    }
  }, [dispatch, editingCardProps, cardProps, form]);

  const layout = React.useMemo(() => {
    // form.resetFields();
    // if (editingCardProps?.type === cardProps?.type) {
    //   dispatch(setCardProps(editingCardProps));
    // }
    switch (type) {
      case CardType.resource:
        return 'horizontal';
      case CardType.video:
        return 'horizontal';
      default:
        return 'vertical';
    }
  }, [type]);

  const labelCol = React.useMemo(() => {
    switch (type) {
      case CardType.graphic:
        return 7;
      case CardType.profile:
        return 10;
      case CardType.resource:
        return 2;
      case CardType.video:
        return 2;
      default:
        return 5;
    }
  }, [type]);

  const ActiveForm = React.useMemo<
    React.FC<{
      form: FormInstance;
      validationFailed;
      saving;
      setFormType;
      editorRef;
      setEditorRef;
    }>
  >(() => {
    // form.resetFields();
    // if (editingCardProps?.type === cardProps?.type) {
    //   dispatch(setCardProps(editingCardProps));
    // }
    switch (type) {
      case CardType.resource:
        return ResourceForm;
      case CardType.video:
        return VideoForm;
      case CardType.definition:
        return DefinitionForm;
      case CardType.quote:
        return QuoteForm;
      case CardType.activity:
        return ActivityForm;
      case CardType.highlight:
        return HighlightForm;
      case CardType.list:
        return ListForm;
      case CardType.factoid:
        return FactoidForm;
      case CardType.graphic:
        return GraphicForm;
      case CardType.quiz:
        return QuizForm;
      case CardType.poll:
        return PollForm;
      case CardType.profile:
        return ProfileForm;
      case CardType.text:
        return TextForm;
      case CardType.welcome:
      case CardType.portrait:
        return () => null;
      default:
        return () => null;
    }
  }, [type]);

  return (
    <div className="modal-form">
      <Form
        name="feedCardForm"
        form={form}
        hideRequiredMark
        colon={false}
        layout={layout}
        labelCol={{ span: labelCol }}
      >
        <ActiveForm
          form={form}
          validationFailed={validationFailed}
          saving={saving}
          setFormType={setFormType}
          editorRef={editorRef}
          setEditorRef={setEditorRef}
        />
      </Form>
    </div>
  );
};

export default CardCreateForm;
